import domain from './domain';

// Reset member list of a personal team
export const resetClientTeamMembers = domain.createEvent('resetClientTeamMembers');

// Reset list of participation in some other team
export const resetClientTeamParticipationList = domain.createEvent('resetClientTeamParticipationList');
